<template>
  <div class="home">
    <anav :loginStatus="loginStatus" />
    <top :config="config"/>
    <div class="content main clearfix">
      <tab :tabId="tabId" :config="config" @updateTabId="updateTabId"/>
      <acontent ref="content" :isFine="isFine" :config="config"/>
    </div>
    <afooter :footerList="footerList" :cnzzKey="cnzzKey" />
    <rightFixed />
  </div>
</template>

<script>
import { GetLoginStatus, GetFooterByHost, getSeniorFlag, Statistics, GetTitleTimeDaoHang } from "../../lib/request"
import anav from "./cell/nav"
import top from "./cell/top"
import tab from "./cell/tab"
import acontent from "./cell/content"
import afooter from "./cell/footer"
import rightFixed from "./cell/rightFixed"
export default {
  name: "Home",
  components: {
    anav,
    top,
    tab,
    acontent,
    afooter,
    rightFixed
  },
  data() {
    return {
      loginStatus: {},
      footerList: [],
      isFine: false,
      cnzzKey: "",
      config: {},
      tabId: 0
    }
  },
  watch: {
    "$route.query"() {
      window.location.reload()
    }
  },
  created() {
    this.tabId = +this.$route.query.id
    this.GetTitleTimeDaoHang()
  },
  mounted() {
    this.GetLoginStatus()
    this.GetFooterByHost()
    this.Statistics()
  },
  methods: {
    GetLoginStatus() {
      GetLoginStatus({}, (res) => {
        const { Result } = res
        this.loginStatus = Result
        document.title = Result.webName ? "报考指南-" + Result.webName : "报考指南"
      })
    },
    GetFooterByHost() {
      GetFooterByHost({}, (res) => {
        this.footerList = res.Result
      })
    },
    getSeniorFlag() {
      getSeniorFlag({ host: location.host }, (res) => {
        if (res.Result) {
          this.isFine = res.Result
        }
      })
    },
    Statistics() {
      Statistics({}, (res) => {
        const { Result } = res
        this.cnzzKey = Result.Key
        const _script1 = document.createElement("script")
        _script1.type = "text/javascript"
        _script1.src = "https://v1.cnzz.com/z_stat.php?id=" + Result.Key + "&online=1&show=line"
        document.body.appendChild(_script1)
      })
      const _script2 = document.createElement("script")
      _script2.type = "text/javascript"
      _script2.src = "https://s4.cnzz.com/z_stat.php?id=1279941642&web_id=1279941642"
      document.body.appendChild(_script2)
    },
    GetTitleTimeDaoHang() {
      GetTitleTimeDaoHang({ id: this.tabId }, (res) => {
        if (res.ResultDescription) {
          window.location.href = window.location.origin
        } else {
          this.config = res.Result
          const { daoHangList = [] } = res.Result
          if (daoHangList[0]) {
            let _obj = {}
            this.config.daoHangList && this.config.daoHangList.forEach(item => {
              item.child.forEach(ii => {
                if (ii.id === this.tabId) _obj = ii
              })
            })
            const { child = [] } = daoHangList[0]
            _obj = Object.keys(_obj).length === 0 ? child[0] || {} : _obj
            this.updateTabId(this.tabId, true, _obj.title === "辅导课程", _obj.title === "辅导老师", true)
            // this.updateTabId(this.tabId, true, child[0] && child[0].title === "辅导课程", child[0] && child[0].title === "辅导老师", true)
          }
        }
      })
    },
    updateTabId(id, init, coachCourse, coachTeacher, once) {
      if (this.tabId === id && !once) return
      this.tabId = id
      if (init) {
        this.$refs.content.title = ""
        this.$refs.content.content = []
        this.$refs.content.course = []
        this.$refs.content.teacher = []
        !coachCourse && !coachTeacher && this.$refs.content.GetContextById(this.tabId)
        !coachTeacher && (coachCourse ? this.$refs.content.GetFudaoCourse(this.config.classId) : this.$refs.content.GetCourse(this.tabId))
        coachTeacher && this.$refs.content.GetFudaoTeacher(this.config.classId)
        this.$refs.content.title =  coachCourse ? "辅导课程" : coachTeacher ? "辅导老师" : ""
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home{
  .main{
    margin: 30px auto 0;
  }
}
</style>

<style>
.union-hide{
  display: none !important;
}
</style>